export interface HeadingSettings {
  fontSize: string;
  fontWeight: string;
  fontFamily: string;
  fontStyle: string;
  lineHeight: string;
  marginTop: string;
  marginBottom: string;
}

export interface BodySettings {
  fontSize: string;
  lineHeight: string;
  marginBottom: string;
}

export interface QuoteFormatSettings {
  id: string;
  name: string;
  quoteIconColor: string;
  quoteIconSize: string;
  quoteFontSize: string;
  quoteFontWeight: string;
  quoteFontFamily: string;
  quoteFontStyle: string;
  quoteLineHeight: string;
  quoteColor: string;
  attributionFontSize: string;
  attributionFontWeight: string;
  attributionColor: string;
  attributionFontStyle: string;
  backgroundColor: string;
  paddingVertical: string;
  paddingHorizontal: string;
  marginVertical: string;
}

export interface ArticleTypographySettings {
  id?: string;
  brand_id: string;
  h1_settings: HeadingSettings;
  h2_settings: HeadingSettings;
  h3_settings: HeadingSettings;
  body_settings: BodySettings;
  created_at?: string;
  updated_at?: string;
}

export interface TypographyAPIResponse {
  h1: HeadingSettings;
  h2: HeadingSettings;
  h3: HeadingSettings;
  body: BodySettings;
}

export const DEFAULT_TYPOGRAPHY: ArticleTypographySettings = {
  brand_id: '',
  h1_settings: {
    fontSize: '2.25rem',
    fontWeight: '700',
    fontFamily: 'inherit',
    fontStyle: 'normal',
    lineHeight: '1.2',
    marginTop: '2rem',
    marginBottom: '1rem'
  },
  h2_settings: {
    fontSize: '1.75rem',
    fontWeight: '600',
    fontFamily: 'inherit',
    fontStyle: 'normal',
    lineHeight: '1.3',
    marginTop: '1.75rem',
    marginBottom: '0.75rem'
  },
  h3_settings: {
    fontSize: '1.375rem',
    fontWeight: '600',
    fontFamily: 'inherit',
    fontStyle: 'normal',
    lineHeight: '1.4',
    marginTop: '1.5rem',
    marginBottom: '0.5rem'
  },
  body_settings: {
    fontSize: '1.125rem',
    lineHeight: '1.75',
    marginBottom: '1.25rem'
  }
};

export const FONT_WEIGHTS = [
  { value: '100', label: 'Thin (100)' },
  { value: '200', label: 'Extra Light (200)' },
  { value: '300', label: 'Light (300)' },
  { value: '400', label: 'Normal (400)' },
  { value: '500', label: 'Medium (500)' },
  { value: '600', label: 'Semi Bold (600)' },
  { value: '700', label: 'Bold (700)' },
  { value: '800', label: 'Extra Bold (800)' },
  { value: '900', label: 'Black (900)' }
];

export const FONT_STYLES = [
  { value: 'normal', label: 'Normal' },
  { value: 'italic', label: 'Italic' },
  { value: 'oblique', label: 'Oblique' }
];

export const FONT_FAMILIES = [
  { value: 'inherit', label: 'Inherit (Default)' },
  { value: 'system-ui', label: 'System UI' },
  { value: 'Georgia, serif', label: 'Georgia (Serif)' },
  { value: '"Times New Roman", serif', label: 'Times New Roman' },
  { value: 'Arial, sans-serif', label: 'Arial' },
  { value: 'Helvetica, sans-serif', label: 'Helvetica' },
  { value: '"Segoe UI", sans-serif', label: 'Segoe UI' },
  { value: 'Roboto, sans-serif', label: 'Roboto' },
  { value: '"Open Sans", sans-serif', label: 'Open Sans' },
  { value: 'Lato, sans-serif', label: 'Lato' },
  { value: 'Montserrat, sans-serif', label: 'Montserrat' },
  { value: '"Playfair Display", serif', label: 'Playfair Display' },
  { value: 'Merriweather, serif', label: 'Merriweather' },
  { value: '"Source Sans Pro", sans-serif', label: 'Source Sans Pro' },
  { value: '"PT Sans", sans-serif', label: 'PT Sans' },
  { value: '"Courier New", monospace', label: 'Courier New' }
];
